module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/example"
    }
  }, [_vm._v("Example")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/map"
    }
  }, [_vm._v("Map")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/editor"
    }
  }, [_vm._v("Editor")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login/bar"
    }
  }, [_vm._v("Login-bar")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login/tool"
    }
  }, [_vm._v("Login-tool")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/elecomponents",
      "append": ""
    }
  }, [_vm._v("Element Components")])], 1), _vm._v(" "), _c('div', {}, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bb21ba2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 150
// module chunks = 0